import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class NoteTypeApi extends BaseAPI {
  public get: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/NoteType`)).data.output;
  };

  public getNoteTypesForDraft: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/NoteType/GetNoteTypesForDraft`)).data.output;
  };
}

export const noteTypeApi = new NoteTypeApi();
